import FormBody from './form-body'

export default FormBody
